@if (branch(); as branch) {
  <app-pan-action-bar>
    <ol class="inline-flex items-center space-x-1 md:space-x-2">
      @if (compatibleTypes().length > 0) {
        <li>
          <app-pan-button color="info" class="mr-1" icon="edit" (click)="modal.show()">Reclassify Branch</app-pan-button>
        </li>
      }

      <li>
        <a
          panButton
          color="info"
          class="mr-1"
          icon="receipt_long"
          [routerLink]="['/home', 'manage', 'branch', branch.id]"
          [queryParams]="{ subpage: 'billing-history' }"
          panRole
          [roles]="['admin', 'branch-owner', 'branch-manager']"
        >
          View Billing History
        </a>
      </li>

      <li>
        <app-pan-button color="info" class="mr-1" icon="credit_card_gear" (click)="onManageBillingClicked(branch, $event)">
          Manage Billing
        </app-pan-button>
      </li>

      @if (showStripeLink(branch)) {
        <li>
          <a
            panButton
            color="info"
            href="{{ 'https://dashboard.stripe.com/customers/' + branch.stripeCustomerId }}"
            target="_blank"
            icon="open_in_new"
          >
            Open in Stripe
          </a>
        </li>
      }
    </ol>
  </app-pan-action-bar>

  <div class="my-2">
    <app-pan-chip color="info"> Customer Type: {{ branch.customerType | uppercase }} </app-pan-chip>
  </div>

  <app-pan-button-group class="my-2">
    <app-pan-button color="primary" [fill]="view() === 'location' ? 'filled' : 'outline'" (click)="view.set('location')">
      Locations
    </app-pan-button>

    <app-pan-button color="primary" [fill]="view() === 'bundlesummary' ? 'filled' : 'outline'" (click)="view.set('bundlesummary')">
      Purchased Bundles Summary
    </app-pan-button>

    <app-pan-button color="primary" [fill]="view() === 'bundlehistory' ? 'filled' : 'outline'" (click)="view.set('bundlehistory')">
      Bundle Transaction History
    </app-pan-button>

    <app-pan-button color="primary" [fill]="view() === 'bundlepurchase' ? 'filled' : 'outline'" (click)="view.set('bundlepurchase')">
      Purchase Bundles
    </app-pan-button>

    <app-pan-button color="primary" [fill]="view() === 'order' ? 'filled' : 'outline'" (click)="view.set('order')"> Orders </app-pan-button>
  </app-pan-button-group>

  @if (presence[0]?.includes(branch.id.toString()) && presence[1]?.length > 1) {
    <app-pan-inline-alert class="my-2" type="warning" [matTooltip]="presence[1]?.toString()">
      Someone else is editing this branch. You may need to refresh.
    </app-pan-inline-alert>
  }

  @let currentView = view();

  <div class="my-2"></div>

  @switch (currentView) {
    @case ("location") {
      <ag-grid-angular [rowData]="locations()" [columnDefs]="columns" [gridOptions]="tableDef" [loading]="isLoading()"></ag-grid-angular>
    }

    @case ("bundlesummary") {
      <app-bundle-summary-purchase
        [branch]="branch"
        [triggerBundleRefresh]="triggerBundleRefresh"
        (bundleSummaryUpdated)="onBundleSummariesUpdated($event)"
      >
      </app-bundle-summary-purchase>
    }

    @case ("bundlehistory") {
      <app-bundle-transaction-history
        [branch]="branch"
        [triggerBundleRefresh]="triggerBundleRefresh"
        (bundleSummaryUpdated)="onBundleSummariesUpdated($event)"
      >
      </app-bundle-transaction-history>
    }

    @case ("bundlepurchase") {
      <app-stripe-purchase-bundle-ui [branch]="branch"></app-stripe-purchase-bundle-ui>
    }

    @case ("order") {
      <app-stripe-purchase-ui [branch]="branch"></app-stripe-purchase-ui>
    }
  }

  <app-pan-modal #modal class="min-h-0" size="md">
    <div header>Reclassify Branch</div>

    <div body>
      <p>Reclassifying a branch changes its customer type to a compatible one.</p>
      <p>A compatible customer type is a customer type that has available prices for all the current products that each location has.</p>

      <div class="relative mt-8">
        <app-pan-floating-label>Select a new customer type </app-pan-floating-label>
        <ng-select
          placeholder="Customer type"
          [bindValue]="'id'"
          [bindLabel]="'name'"
          [items]="compatibleTypes()"
          [(ngModel)]="selectedCustomerType"
        >
          <ng-template ng-option-tmp let-item="item">
            <p>{{ item.name }}</p>
            <p class="text-sm italic">ID: {{ item.id }}</p>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div footer>
      <app-pan-button color="info" fill="outline" panModalClose class="mr-1">Close</app-pan-button>
      <app-pan-button color="primary" panModalClose (click)="reclassify()">Save</app-pan-button>
    </div>
  </app-pan-modal>
} @else {
  <div class="w-100 p-5 flex justify-center">
    <app-pan-spinner></app-pan-spinner>
  </div>
}
